<cw-ci-data-table #scanResultsDataTable
  tileTitle="Scan Targets"
  tableId="ui-scanTargetsList"
  refreshToolTip="Reload scan target list"
  defaultSortField="deviceName"
  defaultSortDirection="desc"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadTargets($event)"
  (selectHandler)="selectTarget($event)"
  [items]="targetsList"
  [emptyListOverlay]="emptyListOverlay">

  <ng-template #emptyListOverlay>
    <div style="display:flex; flex-direction:column; align-items: center; justify-content: center;">
      <img style="padding-bottom:20px;" src="assets/icons/large/large_icon_company.svg">
      <h2>Integrate with Automate Client</h2>
      <div style="max-width:500px; padding-bottom:20px; text-align: center;">There are no companies on your account mapped to automate clients to run a device scan against. Get started by integrating your primary company.</div>
      <button mat-raised-button color="primary" (click)="integrate($event)">Integrate with Automate Client</button>
    </div>
  </ng-template>

  <cw-ci-table-column columnName="name" columnTitle="Computer Name" sortField="deviceName" searchField="deviceName" filterType="text"></cw-ci-table-column>
  <cw-ci-table-column *ngIf="isCompany" columnName="companyName" columnTitle="Company" filterType="select" [filterOptions]="mappedAccounts"></cw-ci-table-column>
  <cw-ci-table-column columnName="location" columnTitle="Site" sortField="location" searchField="location" filterType="text"></cw-ci-table-column>
  <cw-ci-table-column columnName="type" columnTitle="Type" sortField="type" searchField="type" filterType="text"></cw-ci-table-column> 
  <cw-ci-table-column columnName="operatingSystem" columnTitle="OS" sortField="operatingSystem" searchField="operatingSystem" filterType="text"></cw-ci-table-column>
  <cw-ci-table-column columnName="localIpAddress" columnTitle="IP Address" sortField="localIpAddress" searchField="localIpAddress" filterType="text"></cw-ci-table-column>
  <cw-ci-table-column columnName="lastScanResultTimestamp" columnTitle="Date Scanned" [output]="createdTemplate"></cw-ci-table-column>
  <ng-template let-element #createdTemplate>{{element.lastScanResultTimestamp | date:'short'}}</ng-template>
  <cw-ci-table-column columnName="passCount" columnTitle="Passed" [output]="passed"></cw-ci-table-column>
  <ng-template let-element #passed> 
    <span style= "color:#008000;"> {{element.passCount}}</span>
  </ng-template>
  <cw-ci-table-column columnName="failCount" columnTitle="Failed" [output]="failed"></cw-ci-table-column>
  <ng-template let-element #failed> 
    <span style= "color:#ff0000;"> {{element.failCount}}</span>
  </ng-template>
  <cw-ci-table-column columnName="other" columnTitle="Other" [output]="other"></cw-ci-table-column>
  <ng-template let-element #other>
    {{element.totalCount > 0 ? (element.totalCount - element.passCount - element.failCount) : ''}}
  </ng-template>

  <cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <cw-ci-table-column-action actionToolTip="Execute scan" matIcon="play_circle_outline" actionColor="primary" [element]="element" (clickHandler)="scanTarget($event)"></cw-ci-table-column-action>
    <!-- <cw-ci-table-column-action svgIcon="cw:settings" actionColor="primary" [element]="element" (clickHandler)="selectTarget($event)"></cw-ci-table-column-action> -->
    <cw-ci-table-column-action actionToolTip="View scan results" svgIcon="cw:action_toggle_graph" actionColor="primary" [element]="element" (clickHandler)="selectTarget($event)"></cw-ci-table-column-action>
    <!-- <cw-ci-table-column-action actionToolTip="Schedule recurring scans" matIcon="date_range" actionColor="primary" [element]="element" (clickHandler)="scheduleTargetScan($event)"></cw-ci-table-column-action> -->
  </ng-template>

</cw-ci-data-table>